import { Grid, GridProps, styled } from "@mui/material";
import React from "react";

interface MxListContentSectionProps extends GridProps {
  children: React.ReactNode;
}
const MxListContentSection = (props: MxListContentSectionProps) => {
  return <ContentSection container {...props} />;
};

export default MxListContentSection;

const ContentSection = styled(Grid)(({ theme }) => ({
  backgroundColor: "#fff",
  padding: theme.spacing(2, 1.5),
  borderBottom: "1px solid #c6c5c5",
  [theme.breakpoints.down("md")]: {
    height: "auto"
  },
  [theme.breakpoints.down("sm")]: {
    height: "auto"
  }
}));
